import DateFormatter from "@/utils/DateFormatter";

export default () => ({
  "rownumber": 0,
  "dc": "",
  "prio": "",
  "bol": null,
  "spnr": null,
  "fdat": DateFormatter.dateToNumeric(new Date()),
  "tdat": DateFormatter.dateToNumeric(new Date()),
  "ityp": "1",
  "arso": "",
  "tit": "",
  "isrc": "",
  "isccyy": 0,
  "isurspi": "",
  "lndi": "",
  "ccyy": 0,
  "exid": "",
  "lrkod2": " ",
  "source": "RIGHTS",
  "labl": "",
  "feat": "",
  "vers": "",
  "grp": "",
  "bil": "",
  "dur": 0,
  "clas": "",
  "comp": "",
  "right_action": "",
  "revoke": "false",
})